import { AxiosAdapter as CoreAxiosAdapter } from '@core/adapters';
import { ROUTE_NAME } from '@infra/constants';
import {
  AxiosError,
  InternalAxiosRequestConfig /*AxiosResponse */,
} from 'axios';
// import { useCommonStore } from '@stores';

// 호출부에서 자체적으로 폴백 처리하므로 500 에 한해 공통 에러 알럿을 띄우지 않는 요청.
// 400(위약 설정 누락 등)은 공통 알럿을 그대로 노출한다.
// TODO: 위약 조회 API 500 오류 수정 후 제거 검토.
const SILENT_SERVER_ERROR_URL_PATTERNS = [/\/reservations\/\d+\/penalty$/];

export class AxiosAdapter extends CoreAxiosAdapter {
  // protected commonStore = useCommonStore();

  // 공통 에러 알럿 대상에서 제외 (기존 /weathers 예외 처리와 동일한 방식)
  async handleErrorResponse(error: AxiosError<any>) {
    const url = error.config?.url ?? '';
    if (
      error.response?.status === 500 &&
      SILENT_SERVER_ERROR_URL_PATTERNS.some((pattern) => pattern.test(url))
    ) {
      return;
    }

    return super.handleErrorResponse(error);
  }

  async handle401Error(
    errorMessage: string,
    errorCode: string | number,
    errorData: any = null
  ) {
    console.error('401 Unauthorized Error =====');
    switch (errorCode) {
      case 'SIGNUP_AVAILABLE': {
        this.userStore.setUserInfoFromOAuth(errorData);
        break;
      }
      default: {
        console.warn(`Unhandled error code: ${errorCode}`);
        await this.alertStore.showAlertDialog(errorMessage);
        this.commonStore.clearAccessToken();
        await this.router.push({ name: ROUTE_NAME.SignIn });
        break;
      }
    }
  }

  // 골프장별 요청 헤더 설정
  handleRequest(
    config: InternalAxiosRequestConfig
  ): InternalAxiosRequestConfig {
    // 부모 클래스의 handleRequest 실행
    config = super.handleRequest(config);

    // 추가적인 ccType 헤더 설정
    const ccType = this.commonStore.ccType;
    if (config.headers) {
      config.headers.ccType = ccType;
    }
    // this.commonStore.setIsLoading(true);
    return config;
  }
  //
  // // Response 처리 (성공)
  // handleResponse(response: AxiosResponse): AxiosResponse {
  //   //  로딩 종료
  //   this.commonStore.setIsLoading(false);
  //
  //   // 부모 클래스 로직 실행 (settingStore 등)
  //   return super.handleResponse(response);
  // }
  //
  // // Response 에러 처리
  // async handleResponseError(
  //   error: AxiosError<{ data: string; status: string }>
  // ): Promise<AxiosError> {
  //   // 로딩 종료
  //   this.commonStore.setIsLoading(false);
  //
  //   // 부모 클래스 에러 처리
  //   return super.handleResponseError(error);
  // }
  //
  // // 요청 에러 처리 (Request 단계에서 실패한 경우)
  // handleRequestError(error: AxiosError): Promise<AxiosError> {
  //   // 로딩 종료
  //   this.commonStore.setIsLoading(false);
  //
  //   return super.handleRequestError(error);
  // }
}
